import React from "react";
import { Button, Tooltip } from "antd";
import {
  MessageOutlined,
  EditOutlined,
  DeleteOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import styles from "./AssistantCard.module.scss";

/**
 * AssistantCard — tarjeta compacta de asistente IA (design system).
 *
 * Galeria de personaje: el AVATAR es el protagonista (cuadrado, sobre tinte
 * mint), con el nombre, un chip de propiedad (Educa360 / Mio) y el boton
 * primario "Chatear" a ancho completo. En los propios, editar/borrar discretos
 * en la esquina. Pensada para listados de asistentes en rejilla compacta.
 *
 * Props:
 *  - name: string
 *  - avatar?: string (URL de la miniatura)
 *  - ownerLabel?: string (texto del chip; default "Educa360")
 *  - ownerVariant?: "official" | "mine" (color del chip; default "official")
 *  - chatLabel?: string (texto del boton; default "Chatear")
 *  - onChat?: () => void
 *  - chatLoading?: boolean
 *  - canEdit?: boolean (muestra editar/borrar)
 *  - onEdit?: () => void
 *  - onDelete?: () => void
 *  - editLabel?: string
 *  - deleteLabel?: string
 */
export function AssistantCard({
  name,
  avatar,
  ownerLabel = "Educa360",
  ownerVariant = "official",
  chatLabel = "Chatear",
  onChat,
  chatLoading = false,
  canEdit = false,
  onEdit,
  onDelete,
  editLabel = "Editar",
  deleteLabel = "Eliminar",
}) {
  const chipClass = `${styles.chip} ${
    ownerVariant === "mine" ? styles.chipMine : styles.chipOfficial
  }`;

  return (
    <div className={styles.card}>
      {canEdit ? (
        <div className={styles.corner}>
          <Tooltip title={editLabel}>
            <Button
              type="text"
              size="small"
              aria-label={editLabel}
              icon={<EditOutlined />}
              onClick={onEdit}
              className={styles.cornerBtn}
            />
          </Tooltip>
          <Tooltip title={deleteLabel}>
            <Button
              type="text"
              size="small"
              aria-label={deleteLabel}
              icon={<DeleteOutlined />}
              onClick={onDelete}
              className={`${styles.cornerBtn} ${styles.cornerDanger}`}
            />
          </Tooltip>
        </div>
      ) : null}

      <div className={styles.thumb}>
        {avatar ? (
          <img src={avatar} alt={name} loading="lazy" />
        ) : (
          <RobotOutlined className={styles.thumbIcon} />
        )}
      </div>

      <div className={styles.name} title={name}>
        {name}
      </div>

      <span className={chipClass}>
        <span className={styles.dot} />
        {ownerLabel}
      </span>

      <Button
        type="primary"
        block
        icon={<MessageOutlined />}
        loading={chatLoading}
        onClick={onChat}
        className={styles.chatBtn}
      >
        {chatLabel}
      </Button>
    </div>
  );
}

export default AssistantCard;
